import {CsvTableViewer, MarkdownAtom, markdownService, MarkdownViewer} from '@dv5/components'
import {DocumentPart, PartType} from '@dv5/domain'
import {FC} from "react"
import {DiaryViewer} from "./diary/DiaryViewer"
import {SecretViewer} from "./SecretViewer"

interface Props {
    part: DocumentPart
    onChange: (partId: string, newContent: string) => void
}

export const DocumentPartViewer: FC<Props> = ({
                                                  part,
                                                  onChange,
                                              }) => {
    const toggleCheckBox = (atom: MarkdownAtom) => {
        const newText = markdownService.getAfterToggleCheckbox(part.partContent, atom)
        onChange(part.id, newText)
    }
    const changeCSV = (newCSVSource: string) => {
        onChange(part.id, newCSVSource)
    }

    if (part.partType === PartType.MARKDOWN) {
        return (
            <MarkdownViewer compactMode={false} sourceCode={part.partContent} onToggleCheckBox={toggleCheckBox}/>
        )
    }
    if (part.partType === PartType.CSV_TABLE) {
        return (
            <CsvTableViewer sourceCode={part.partContent} editable={true} onChange={changeCSV} />
        )
    }
    if (part.partType === PartType.DIARY) {
        return (
            <DiaryViewer part={part} onChange={onChange}/>
        )
    }
    if (part.partType === PartType.SECRET) {
        return (
            <SecretViewer part={part}/>
        )
    }

    return (
        <pre>{part.partContent}</pre>
    )
}
